/* TODO: fix this: consider to merge / generalize this with "_CollapsibleMobileMenuController"
 * Lots of the features of this component are similar to the
 * features of component "_CollapsibleMobileMenuController" */

import React from 'react';
import PropTypes from 'prop-types';
import { ButtonOBSOLETED } from '../../../web.common';
import { manageEventListener, onClickOutsideElement } from '../../../common/utils';
import withLocalization from '../../higherOrderComponents/withLocalization';

class AreaWithSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isSidebarOpen: false };

    this.refSidebar = React.createRef();
    this.clickAreaClassName = 'sidebar-click-area';
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.manageEventListeners = this.manageEventListeners.bind(this);
    this.handleClickEvent = this.handleClickEvent.bind(this);
    this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this);
  }

  componentDidMount() {
    this.manageEventListeners('add');
  }

  componentWillUnmount() {
    this.manageEventListeners('remove');
  }

  toggleSidebar(isSidebarOpen) {
    this.setState(actualState => {
      if (actualState.isSidebarOpen !== isSidebarOpen) {
        return { isSidebarOpen: typeof (isSidebarOpen) !== 'undefined' ? isSidebarOpen : !actualState.isSidebarOpen };
      }
    });
  }

  handleClickEvent(event) {
    const {
      toggleSidebar,
      clickAreaClassName
    } = this;

    onClickOutsideElement(event, `.${clickAreaClassName}`, () => {
      toggleSidebar(false);
    });
  }

  handleKeyUpEvent({ key }) {
    if (key === 'Escape') {
      this.toggleSidebar(false);
    }
  }

  manageEventListeners(action) {
    const {
      handleClickEvent,
      handleKeyUpEvent
    } = this;

    const events = [
      {
        target: document,
        event: 'click',
        func: handleClickEvent
      },
      {
        target: document,
        event: 'keyup',
        func: handleKeyUpEvent
      }
    ];

    events.forEach(({ target, event, func }) => manageEventListener(target, event, action, func));
  }

  render() {
    const {
      props: {
        renderSidebarContent,
        classNames: passedClassNames = [],
        translate,
        children
      },
      state: {
        isSidebarOpen
      },
      clickAreaClassName,
      toggleSidebar,
      refSidebar
    } = this;

    const classNames = ['sidebared-layout-wrap', ...passedClassNames];

    if (isSidebarOpen) {
      classNames.push('sidebar-open');
    }

    if (!renderSidebarContent) {
      classNames.push('sidebar-hidden');
    }

    return (
      <div className={classNames.join(' ')}>
        <div className={`sidebar-toggler-wrap ${clickAreaClassName}`}>
          <ButtonOBSOLETED
            onClick={() => toggleSidebar()}
            appearance='buttonOutline'
            buttonColor='white'
            className='button-toggler'
            iconName='bars'
            ariaLabel={translate('button-toggler-ariaLabel')}
            ariaExpanded={isSidebarOpen}
            disabled={!renderSidebarContent}
            sameTextAndIconColor
          />
        </div>

        <aside className={`sidebar ${clickAreaClassName}`} ref={refSidebar}>
          {renderSidebarContent ? renderSidebarContent({ toggleSidebar }) : null}
        </aside>

        <div className='content-width-limiter-wide'>
          {children}
        </div>
      </div>
    );
  }
}

AreaWithSidebar.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  renderSidebarContent: PropTypes.func
};

export default withLocalization(AreaWithSidebar, 'layout/sidebar');